import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginTop: 0,
    },
  },
  parts: {
    width: '100%',
    '& td': {
      width: '50%',
      cursor: 'pointer',
      padding: '0.25em 0.5em',
      '&:nth-child(1)': {
        textAlign: 'right',
        background: '#ffeb60',
      },
      '&:nth-child(2)': {
        background: '#d1d1ff',
      },
    },
  },
  done: {
    border: '2px solid ' + theme.palette.primary.main,
    borderRadius: 10,
    padding: 10,
    marginBottom: 20,
    '& p': {
      textAlign: 'center',
      lineHeight: 1.3,
      margin: '0.25em 0',
    },
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

let active1 = true;
let active2 = true;
let timeout = 0;

function NewExercise(props) {
  const classes = useStyles();
  const [done, setDone] = useState([]);
  const [random, setRandom] = useState(false);
  const [sentences, setSentences] = useState(false);
  const [selected1, setSelected1] = useState(false);
  const [selected2, setSelected2] = useState(false);
  const [finished, setFinished] = useState(false);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;

  useEffect(() => {
    init();
    return () => {
      clearTimeout(timeout);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selected1 === false || selected2 === false) return;
    if (sentences[selected1].part1 === random[selected2].part1) {
      correct();
    } else {
      incorrect();
    }
    // eslint-disable-next-line
  }, [selected1, selected2]);

  const init = () => {
    setRandom(shuffle([...exercise]));
    setSentences([...exercise])
    startStats(type);
    setFinished(false);
  }

  const correct = () => {
    props.media.success();
    timeout = setTimeout(() => {
      const s = [...sentences];
      const current = s.splice(selected1, 1)[0];
      setSentences(s);
      setSelected1(false);
      setSelected2(false);
      active1 = true;
      active2 = true;
      if (random.length === 1) finish();
      setRandom(random.filter(r => r.part1 !== current.part1));
      setDone([...done, current]);
    }, 1500);
  }

  const incorrect = () => {
    props.media.failure();
  }

  const finish = () => {
    finishExercise();
    setFinished(true);
    props.media.finish();
  }

  const getStyle1 = idx => {
    const style = { fontWeight: selected1 === idx ? 600 : 400 };
    if (selected1 !== false && selected2 !== false && selected1 === idx) {
      style.color = sentences[selected1].part1 === random[selected2].part1 ? '#00a000' : 'red';
    }
    return style;
  }

  const getStyle2 = idx => {
    if (selected1 === false || selected2 === false || selected2 !== idx) return {};
    if (!sentences[selected1]) return {}
    const style = {
      fontWeight: selected2 === idx ? 600 : 400,
      color: sentences[selected1].part1 === random[selected2].part1 ? '#00a000' : 'red',
    }
    return style;
  }

  const select1 = (idx) => {
    action();
    if (!active1) return;
    setSelected1(idx);
    setSelected2(false);
    active2 = true;
  }

  const select2 = (idx) => {
    action();
    if (!active2 || selected1 === false) return;
    active2 = false;
    if (sentences[selected1].part1 === random[idx].part1) {
      active1 = false;
    }
    setSelected2(idx);
  }

  if (!random) return '';

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Dopasuj części zdania</h3>
        {done.length > 0 && <div className={classes.done}>
          {done.map(parts => <p key={parts.part1}>{parts.part1} {parts.part2}</p>)}
        </div>}
        <table className={classes.parts}>
          <tbody>
            {sentences.map((part, idx) => <tr key={part.part1}>
              <td onClick={() => select1(idx)} style={getStyle1(idx)}>{part.part1}</td>
              <td onClick={() => select2(idx)} style={getStyle2(idx)}>{random[idx].part2}</td>
            </tr>)}
          </tbody>
        </table>
        {finished && <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>
        </div>}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  }
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export default connect(mapStateToProps)(NewExercise);